import React, { useEffect, useRef, useState } from 'react';

// Test ids are snake_case: "Point Guard" -> point_guard, "GA" -> ga.
export const optSlug = (v) => String(v).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

// One pill filter on the Find & add tab. Unset it shows its name ("State"); set it shows the
// value ("TN") on the dark pill. The menu closes on an outside mousedown, like ListHeader's ⋯ menu.
// options: [{ value, label }]; onPick('') unsets.
export default function FilterChip({ name, testId, value, valueLabel, options, onPick }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const pick = (v) => { setOpen(false); onPick(v); };
  const set = Boolean(value);

  return (
    <span className="ls-menu-wrap" ref={ref}>
      <button type="button" className={`ls-fchip${set ? ' ls-fchip--set' : ''}`} aria-haspopup="menu" aria-expanded={open}
        aria-label={set ? `${name}: ${valueLabel || value}` : name} onClick={() => setOpen((v) => !v)} data-testid={testId}>
        <span className="ls-fchip__label">{set ? (valueLabel || value) : name}</span>
        <span className="ls-fchip__caret" aria-hidden="true">▼</span>
      </button>
      {open && (
        <div className="ls-menu ls-menu--chip" role="menu" data-testid={`${testId}_menu`}>
          <button type="button" role="menuitem" className="ls-menu__item ls-menu__item--muted"
            onClick={() => pick('')} data-testid={`${testId}_opt_any`}>{`Any ${name.toLowerCase()}`}</button>
          {options.map((o) => (
            <button type="button" role="menuitem" key={o.value}
              className={`ls-menu__item${String(o.value) === String(value) ? ' ls-menu__item--on' : ''}`}
              onClick={() => pick(o.value)} data-testid={`${testId}_opt_${optSlug(o.value)}`}>{o.label}</button>
          ))}
        </div>
      )}
    </span>
  );
}
